<template>
  <PickupAdShowList :is-loading="isLoading" :pickup-ads="releasedPickupAds" @read="handleRead" />
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions, mapGetters } = createNamespacedHelpers('pickupAd');
import toastr from '@v2/atoms/clinic/WideToastr.vue';
import PickupAdShowList from '@v2/organisms/common/pickup_ads/ShowList.vue';

export default {
  name: 'PickupAdContainer',
  components: { PickupAdShowList },
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    ...mapGetters(['clinicPickupAds']),
    releasedPickupAds() {
      if (this.clinicPickupAds.length < 1) return [];

      const pickupAds = this.clinicPickupAds.map((p) => ({
        imageUrl: p.image_url,
        sponsorName: p.sponsor_name,
        title: p.title,
        articleUrl: p.article_url,
        tag: p.tag,
        tagColor: p.tag_color,
        deliveredPickupAdId: p.delivered_pickup_ad_id,
        isRead: p.is_read,
      }));

      return pickupAds;
    },
  },
  async created() {
    await this.fetchClinicPickupAds()
      .then(() => {
        this.loading = false;
      })
      .catch(() => {
        toastr.error(`ピックアップの取得に失敗しました`);
      });
    this.isLoading = false;
  },
  methods: {
    ...mapActions(['fetchClinicPickupAds', 'updateDeliveredPickupAd']),
    async handleRead(delivered_pickup_id) {
      await this.updateDeliveredPickupAd(delivered_pickup_id);
    },
  },
};
</script>
